import uuid from 'uuid/v1';
import { bugsnagClient as bugsnag } from 'logger/bugsnag';

// const getSegmentInstance = () => {
//   let segment = window.analytics;
//   if (!segment) {
//     segment =
//   }
// };

// export const trackPage = payload => {
//   const analytics = getSegmentInstance();
//   analytics.page(payload);
// }

export const getUserId = () => {
  const existingUUID = localStorage.getItem('trumpCapsuleUUID');
  if (!existingUUID) {
    const userId = uuid();
    localStorage.setItem('trumpCapsuleUUID', userId);
    return userId;
  }
  return existingUUID;
};

export const identify = () => {
  const userId = getUserId();

  // Log user to analytics
  window.analytics.identify({
    anonymousId: userId
  });

  // Log user to error handler
  bugsnag.user = {
    id: userId
  };
};

export const track = (eventName, data) => {
  window.analytics.track(eventName, data);
};



// WEBPACK FOOTER //
// ./src/services/analytics.js